module.exports = __webpack_public_path__ + "static/img/185_TO8_2048.e647a90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/185_TO8_2048.jpg
// module id = wceD
// module chunks = 0